// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"596":"f65be896","614":"64250497","876":"594d3ca1"}[chunkId] + ".chunk.css";
};